module.exports = __webpack_public_path__ + "img/制御工学5_9.2924a992.png";